import { useLang } from "@/i18n/LanguageContext";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import DemoDialog from "./DemoDialog";
import { track, REGISTER_URL } from "@/lib/analytics";

const toneBg: Record<string, string> = {
  mint: "bg-mint text-mint-foreground",
  coral: "bg-coral text-coral-foreground",
  butter: "bg-butter text-butter-foreground",
  lavender: "bg-lavender text-lavender-foreground",
};

const Pricing = () => {
  const { t } = useLang();
  return (
    <section id="pricing" className="py-24 md:py-32 bg-butter">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-butter-foreground">{t.pricing.eyebrow}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl md:text-6xl font-extrabold leading-[1.05] text-butter-foreground">{t.pricing.title}</h2>
          <p className="mt-5 text-lg md:text-xl text-butter-foreground/80">{t.pricing.desc}</p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {t.pricing.columns.map((c) => (
            <div key={c.who} className={`rounded-3xl p-8 ${toneBg[c.tone]} shadow-card`}>
              <div className="text-sm font-bold uppercase tracking-widest opacity-70">{c.who}</div>
              <div className="mt-3 text-6xl font-extrabold tracking-tight">{c.price}</div>
              <div className="mt-2 text-sm font-bold opacity-80">{c.sub}</div>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-3xl mx-auto rounded-[2rem] bg-background shadow-elegant p-8 md:p-10">
          <div className="flex items-center gap-3 flex-wrap">
            <div className="inline-flex items-center rounded-full bg-primary text-primary-foreground px-4 py-1.5 text-sm font-bold">
              {t.pricing.feeBadge}
            </div>
            <p className="text-sm text-muted-foreground">{t.pricing.feeNote}</p>
          </div>

          <div className="mt-6 text-sm font-bold">{t.pricing.includes}</div>
          <ul className="mt-3 grid sm:grid-cols-2 gap-3">
            {t.pricing.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm">
                <span className="mt-0.5 inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary text-primary-foreground shrink-0">
                  <Check className="h-3 w-3" />
                </span>
                {b}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer" onClick={() => track("register_click", "pricing")} className="flex-1">
              <Button size="lg" className="w-full rounded-full h-12 text-base">{t.pricing.cta}</Button>
            </a>
            <DemoDialog
              trigger={
                <Button size="lg" variant="outline" className="rounded-full h-12 text-base">{t.pricing.secondaryCta}</Button>
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
